import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=3a14c7e2&"
import script from "./consume.vue?vue&type=script&lang=js&"
export * from "./consume.vue?vue&type=script&lang=js&"
import style0 from "./consume.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports